import { render, staticRenderFns } from "./Performer.vue?vue&type=template&id=0c524b42&scoped=true&"
import script from "./Performer.vue?vue&type=script&lang=js&"
export * from "./Performer.vue?vue&type=script&lang=js&"
import style0 from "./Performer.vue?vue&type=style&index=0&id=0c524b42&prod&lang=scss&scoped=true&"
import style1 from "./Performer.vue?vue&type=style&index=1&id=0c524b42&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c524b42",
  null
  
)

export default component.exports